import { addContactsWhoBlockedMe } from '../../Redux/feature/contactsWhoBlockedMeSlice';
import { store } from '../../Redux/store';
import { formatUserIdToJid } from './User';

/**
 * @param {*} dataArr
 */
export const formatToArrayofJid = (dataArr) => {
    return dataArr.map(data => formatUserIdToJid(data.jid));
}

export const setContactWhoBlockedMe = (data) => {
    store.dispatch(addContactsWhoBlockedMe(data));
}

export const isUserIBlocked = (userJid) => {
    if(!userJid) return false;
    const state = store.getState();
    const blockedContact = (state.blockedContact && state.blockedContact.data) || [];
    userJid = formatUserIdToJid(userJid);
    return blockedContact.indexOf(userJid) > -1;
}

export const isUserWhoBlockedMe = (userJid) => {
    if(!userJid) return false;
    const state = store.getState();
    const contactsWhoBlockedMe = (state.contactsWhoBlockedMe && state.contactsWhoBlockedMe.data) || [];
    userJid = formatUserIdToJid(userJid);
    return contactsWhoBlockedMe.indexOf(userJid) > -1;
}
